export default __webpack_public_path__ + "static/media/logo_palpite - Copia.00d51758.png";